import { useSelector } from 'react-redux';

import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';

function useCanUploadContract(): boolean {
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  return profile?.alfa_tester === true;
}

export default useCanUploadContract;
